/**
 * `--e1..--e4` from `tokens.css`, mapped onto MUI's 25-slot `shadows` array
 * (index 0 is always `'none'`; MUI requires every slot filled, and this app
 * never needs more than four distinct elevations).
 */
import type { Shadows } from '@mui/material/styles';

/* The tokens themselves, so a shadow follows light / dark with the rest. */
const elevation1 = 'var(--e1)';
const elevation2 = 'var(--e2)';
const elevation3 = 'var(--e3)';
const elevation4 = 'var(--e4)';

export const shadows: Shadows = [
	'none',
	elevation1,
	elevation2,
	...Array.from({ length: 6 }, () => elevation3),
	...Array.from({ length: 16 }, () => elevation4),
] as Shadows;
